import apiClient from "../../utils/apiclient";

export const viewretailers=async(token:string)=>{
   return await apiClient.get('/admin/task/view-retailers',{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
}